import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const FiltersContainer = styled.div<{
  paddingBottom: number;
}>`
  flex-grow: 2;
  overflow-y: auto;
  padding: ${(props) => `0 20px ${props.paddingBottom}px 20px`};
  height: 400px;
`;

export const FiltersHeader = styled.div`
  display: flex;
  align-items: center;
  width: 620px;
  margin: 0 20px;
`;

export const FiltersTitle = styled.h3`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodyLargeSemibold
      : textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 0 16px 0 0;
  width: 100%;
  text-align: center;
`;

export const StyledCloseIcon = styled(StyledIcon)`
  cursor: pointer;
`;

export const FiltersFooter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 620px;
  margin: 20px 20px 0 20px;
`;
